import { getToken } from '../util/storage';

const REGISTRY_URL = process.env.REACT_APP_REGISTRY_URL || '/api/vehicle-registry';

async function fetchWithAuth(url, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  const response = await fetch(url, {
    ...options,
    headers,
  });

  if (response.status === 401) {
    throw new Error('Unauthorized');
  }

  if (!response.ok) {
    const text = await response.text();
    throw new Error(text || 'Request failed');
  }

  return response.json();
}

export async function getVehicles() {
  return fetchWithAuth(`${REGISTRY_URL}/vehicles`);
}

export async function getVehicle(id) {
  return fetchWithAuth(`${REGISTRY_URL}/vehicles/${id}`);
}

export async function getFleets() {
  return fetchWithAuth(`${REGISTRY_URL}/fleets`);
}

export async function getFleet(id) {
  return fetchWithAuth(`${REGISTRY_URL}/fleets/${id}`);
}

export async function getFleetVehicles(fleetId) {
  return fetchWithAuth(`${REGISTRY_URL}/fleets/${fleetId}/vehicles`);
}
